<div
  class="notification-item d-flex align-items-start gap-2 p-2"
  [class.notification-item--unread]="!notification().read"
  [caLocalizationScope]="localizationScope"
  data-automation-id="reporting-notification-item"
>
  <!-- Download button (success only) / unread dot space kept for error state -->
  <div class="notification-dot-container d-flex justify-content-center flex-shrink-0 mt-1">
    @if (!hasError() && hasDownload()) {
    <a
      class="btn btn-icon"
      type="button"
      (click)="onDownload()"
      data-automation-id="download-report-btn"
      [title]="'download' | caLocalize"
    >
      <i class="f-i f-i-export f-i-sm"></i>
    </a>
    } @else { @if (!notification().read) {
    <span
      class="notification-unread-dot d-block bg-primary rounded-circle"
      data-automation-id="unread-indicator"
    ></span>
    } }
  </div>

  <!-- File icon — danger when error, muted when success -->
  <div class="flex-shrink-0 mt-1" data-automation-id="file-icon">
    <i class="f-i f-i-file f-i-sm" [class.text-danger]="hasError()" [class.text-muted]="!hasError()"></i>
  </div>

  <!-- Content -->
  <div class="flex-grow-1 overflow-hidden">
    @if (hasError()) {
    <!-- === ERROR STATE === -->
    <div class="d-flex justify-content-between align-items-center gap-1">
      <p
        class="body-70 text-danger text-truncate mb-1"
        [title]="body()?.reportName || notification().title"
        data-automation-id="notification-title"
      >
        {{ body()?.reportName || notification().title }}
      </p>
      <a
        class="btn btn-icon"
        type="button"
        (click)="onDelete()"
        data-automation-id="delete-notification-btn"
        [title]="'delete' | caLocalize"
      >
        <i class="f-i f-i-close f-i-sm"></i>
      </a>
    </div>

    <p class="small text-danger mb-1" data-automation-id="error-message">
      {{ body()?.errorMessage }}
    </p>
    } @else {
    <!-- === SUCCESS STATE === -->
    <div class="d-flex justify-content-between align-items-center gap-1">
      <p
        class="text-truncate mb-1"
        [title]="body()?.reportName || notification().title"
        data-automation-id="notification-title"
      >
        {{ body()?.reportName || notification().title }}
      </p>
      <a
        class="btn btn-icon"
        type="button"
        (click)="onDelete()"
        data-automation-id="delete-notification-btn"
        [title]="'delete' | caLocalize"
      >
        <i class="f-i f-i-close f-i-sm"></i>
      </a>
    </div>

    @if (subtitle()) {
    <p class="small text-muted mb-1" data-automation-id="report-subtitle">
      {{ subtitle() }}
    </p>
    } }
  </div>
</div>
